<template>
  <v-app>
    <v-data-table
      :page="page"
      :pageCount="numberOfPages"
      :options.sync="options"
      :server-items-length="totalItems"
      :headers="headers"
      :items="items"
      :search="search"
      class="elevation-1"
      :loading="loading"
      loading-text="Đang tải dữ liệu... Vui lòng chờ"
      :items-per-page="10"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Thông tin sâu bệnh, dịch hại</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nhập từ khóa"
            single-line
            hide-details
            clearable
          />
          <v-spacer/>
          <v-btn
            color="primary"
            text
            class="mb-2 mr-2"
            @click="showFilterDialog"
          >
            <v-icon class="mr-2">mdi-filter-variant-plus</v-icon>
            <span v-if="$vuetify.breakpoint.lgAndUp">
              tìm nâng cao
            </span>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                dark
                class="mb-2 mr-2"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon class="mr-2" small>
                  mdi-arrow-collapse-down
                </v-icon>
                Tải về
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(type, index) in exportTypes"
                :key="index"
                @click="exportData(type)"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ type.toUpperCase() }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
          <NView
            :showDialog="dialog" 
            :item="item" 
            @confirmed="onConfirmed" 
            @cancelled="onCancelled"
          />
          <FormFilter 
            :showDialog="dialogFilter" 
            @confirmed="onFilterConfirmed" 
            @cancelled="onFilterCancelled"
          />
        </v-toolbar>
      </template>
      <template v-slot:item.anh_dai_dien="{ item }">
        <v-img
          v-if="item.anh_dai_dien"
          :src="`${apiBaseUrl}/uploads/${item.anh_dai_dien}`"
          class="ma-4"
          width="70"
        >
        </v-img>
        <v-img
          v-else
          src="@/assets/NoImage.jpg"
          class="ma-4"
          width="70"
        >
        </v-img>
      </template>
      <template v-slot:item.muc_do="{ item }">
        <span v-if="item.muc_do=='WARNING'" class="warning--text">Cảnh báo</span>
        <span v-if="item.muc_do=='DANGER'" class="red--text">Khẩn cấp</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          color="primary"
          v-on:click="showDialog(item)"
        >
          <v-icon small>
            mdi-eye
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Tải lại
        </v-btn>
      </template>
    </v-data-table>
  </v-app>
</template>
<script>
  import FormFilter from '@/views/admin/news/Filter';
  import NView from '@/views/public/news/NewsView';
  import FileSevice from '@/services/File';
  import { mapState } from 'vuex';
  export default {
    components: {
      FormFilter,
      NView
    },
    data: () => ({
      loading: false,
      dialog: false,
      dialogDelete: false,
      dialogFilter: false,
      search: '',
      headers: [
        { text: 'Ảnh', value: 'anh_dai_dien' },
        { text: 'Tiêu đề', value: 'tieu_de' },
        { text: 'Loại', value: 'category.dien_giai' },
        { text: 'Mức độ', value: 'muc_do' },
        { 
          align: 'right', 
          text: 'Thao tác', 
          value: 'actions', 
          sortable: false 
        },
      ],
      items: [],
      page: 1,
      totalItems: 0,
      numberOfPages: 0,
      options: {},
      editedIndex: -1,
      item: {},
      exportTypes: ['xls', 'xlsx'],
      filter: {

      }
    }),
    computed: {
      ...mapState([ 
        'config'
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'thêm mới' : 'cập nhật';
      },
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    watch: {
      options: {
        handler() {
          this.initialize();
        },
      },
      search(){
        this.initialize();
      }
    },
    methods: {
      initialize () {
        this.loading = true;
        const { page, itemsPerPage } = this.options;
        let pageNumber = page;
        let request = {
          params: {
            size: itemsPerPage,
            page: pageNumber,
            check_stat: 1,
            keyword: this.search,
            from: this.filter.tuNgay,
            to: this.filter.denNgay,
            type: this.filter.loaiTin,
            level: this.filter.mucDo,
            status: this.filter.tinhTrang
          }
        };
        axios.get("api/v1/news", request)
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.total;
            this.numberOfPages = response.data.to;
            this.loading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      showDialog(item=null){
        this.item = item||{};
        this.dialog = true;
      },
      onConfirmed(item) {
        this.dialog = false;
        this.initialize();
      },
      onCancelled () {
        this.dialog = false;
      },
      showFilterDialog(){
        this.dialogFilter = true;
      },
      onFilterConfirmed(filter) {
        this.filter=filter;
        this.initialize();
        this.dialogFilter = false;
      },
      onFilterCancelled () {
        this.dialogFilter = false;
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogDelete = true;
      },
      deleteItemConfirm () {
        const app = this;
        axios.delete(`api/v1/news/${app.item.id}`)
          .then(function (resp) {
            app.items = app.items.filter(val => val.id !== app.item.id);
            app.closeDelete();
          }).catch(function (error) {
            console.log(error);
          });
      },
      close () {
        this.dialog = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      closeDelete () {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      exportData(type){
        const app = this;
        app.loading=true;
        let params = {
          namereport: 'thong_tin',
          export_type: type,
          filter: {
            tuNgay: app.filter.tuNgay,
            denNgay: app.filter.denNgay,
            loaiTin: app.filter.loaiTin,
            mucDo: app.filter.mucDo,
            tinhTrang: app.filter.tinhTrang,
            checkStat: 1,
          }
        };
        axios.post('api/v1/export', params, {responseType: 'arraybuffer'})
          .then(function (response) {
            FileSevice.download(response.data, `thong_tin.${type}`);
            app.loading=false;
          }).catch(function (error) {
            console.log(error);
          });
      }
    }
  }
</script>